import { useEffect, useState } from 'react';

import { ZERO } from '@/constants';
import { useSurvey } from '@/hooks';
import { SurveyResponseStatus } from '@/types';

import Data from './Data';
import Header from './Header';
import List from './List';

import type { SurveyResponse, SurveyResult } from '@/types';

const Responses = () => {
  const [selected, setSelected] = useState(ZERO);
  const [show, setShow] = useState(false);
  const { survey, isSurveyLoading } = useSurvey();

  const toggleShow = () => setShow(!show);
  const select = (index: number) => () => setSelected(index);

  const toTime = (value?: Date | string | null) =>
    value ? new Date(value).valueOf() : 0;

  const responses: SurveyResponse[] = [...(survey.responses ?? [])].sort(
    (a, b) =>
      toTime(b.respondedAt ?? b.updatedAt ?? b.createdAt) -
      toTime(a.respondedAt ?? a.updatedAt ?? a.createdAt),
  );

  const respondedCount =
    survey.aggregated?.totalResponses ??
    responses.filter((r) => r.status === SurveyResponseStatus.COMPLETED).length;

  useEffect(() => {
    if (!isSurveyLoading && responses.length) {
      const firstWithResults = responses.findIndex(({ results }) => !!results);
      setSelected(firstWithResults >= ZERO ? firstWithResults : ZERO);
    }
  }, [survey.id, isSurveyLoading, responses.length]);

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="flex flex-col">
        <Header
          respondedCount={respondedCount}
          responses={responses}
          show={show}
          toggleShow={toggleShow}
        />
        <List
          responses={responses}
          select={select}
          selected={selected}
          show={show}
        />
      </div>
      <Data results={(responses[selected]?.results ?? {}) as SurveyResult} />
    </div>
  );
};

export default Responses;
